import { useMemo } from 'react'
import { calcChicago } from './ggChicago.js'
import { samplePlayers, samplePars } from './ggSamplePlayers.js'

// G-Chicago — isolated sandbox. calcChicago ported from GolfGamesScorecard:
// points vs par (albatross 8 / eagle 5 / birdie 2 / par 1 / bogey+ 0), quota
// 39 − handicap, ranked by points over/under quota. READ-ONLY over the sample.
const cell = { border: '1px solid #ddd', padding: '6px 10px', fontSize: 16 }

export default function GChicago() {
  const rows = useMemo(() => calcChicago(samplePlayers(), samplePars()), [])
  return (
    <div className="card">
      <p className="text-sm text-gray-500 mb-3">
        Points vs par: albatross 8 · eagle 5 · birdie 2 · par 1 · bogey+ 0. Quota = 39 − handicap. Beat your quota to win.
      </p>
      <table className="w-full text-base" style={{ borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f6f6f2', color: '#555' }}>
          {['Pos', 'Player', 'Points', 'Quota', '+/−'].map((h) => <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>)}
        </tr></thead>
        <tbody>{rows.map((p, i) => (
          <tr key={p.id}>
            <td style={cell}>{i + 1}</td><td style={cell}>{p.name}</td>
            <td style={cell}>{p.total}</td><td style={cell}>{p.quota}</td>
            <td style={cell}><b style={{ color: p.vsQuota > 0 ? '#1B7A3E' : p.vsQuota < 0 ? '#B42318' : '#374151' }}>{p.vsQuota > 0 ? `+${p.vsQuota}` : p.vsQuota}</b></td>
          </tr>
        ))}</tbody>
      </table>
    </div>
  )
}
